import { render } from "./AppointmentRecordOverlay.vue?vue&type=template&id=2dd45fd0&scoped=true&lang=pug"
import script from "./AppointmentRecordOverlay.vue?vue&type=script&lang=js"
export * from "./AppointmentRecordOverlay.vue?vue&type=script&lang=js"

import "./AppointmentRecordOverlay.vue?vue&type=style&index=0&id=2dd45fd0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd45fd0"]])

export default __exports__